import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createTopic } from '@/services/topicService';

const initialState = {
  currentTopic: null,
  submitting: false,
};

export const createTempTopic = createAsyncThunk('messageSAR/createTempTopic', async (params) => {
  await createTopic({
    note: '系统自动创建-消息收发临时topic',
    isPartitioned: 0,
    messageTraceOpen: 1,
    ...params,
  });
  return params;
});

export const messageSARSlice = createSlice({
  name: 'messageSAR',
  initialState,
  reducers: {
    reset: () => initialState,
    setCurrentTopic: (state, action) => {
      state.currentTopic = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createTempTopic.pending, (state) => {
        state.submitting = true;
      })
      .addCase(createTempTopic.fulfilled, (state, action) => {
        state.currentTopic = action.payload;
        state.submitting = false;
      })
      .addCase(createTempTopic.rejected, (state) => {
        state.submitting = false;
      });
  },
});

export const { setCurrentTopic, reset } = messageSARSlice.actions;
export default messageSARSlice.reducer;
